
import StatCardSection from './Card';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Card6({ survivorsFinalizados }) {

  if (survivorsFinalizados === null || survivorsFinalizados === undefined || survivorsFinalizados === 'empty') {

    return (
      <div className="col-xl-3 col-md-6 mb-4">
        <div className="card shadow h-100 py-2">
          <div className="card-body">
            <Skeleton height={20} width={120} className="mb-2" />
            <Skeleton height={30} width={80} />
          </div>
        </div>
      </div>
    );
  }

  return (

    <StatCardSection
      title="SURVIVORS FINALIZADOS"
      value={survivorsFinalizados}
      color="success"
      icon="fa-user-check"

    />
  );
}
